import config from 'config'

export default {
  findCity: `${config.resourceHost}find/city/`,
  statistic: `${config.resourceHost}statistic/`,
  estimationStats: `${config.resourceHost}statistic/`,
  widgets: `${config.resourceHost}widgets/`,
  cashflow: `${config.resourceHost}statistic/cashflow`,
  documentList: `${config.resourceHost}documents`,
  users: `${config.resourceHost}user`,
}
